module.exports = __webpack_public_path__ + "media/images/job_description-112d48f66d99ffeeb05772bdc61bb0fd.svg";